<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="sampleSetSampleForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                sampleSetSampleForm: () => import('../forms/SampleSetSampleForm'),
                headers: [
                    { text: 'Sample Set', value: 'sampleSetId', table: 'sampleSets', form: () => import('../forms/SampleSetForm') },
                    { text: 'Sample', value: 'sampleId', table: 'samples', form: () => import('../forms/SampleForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    samples: [],
                    sampleSets: [],
                    items: []
                },
                sorting: [
                    { column: "sampleSetId", direction: "ascending" },
                    { column: "sampleId", direction: "ascending" },
                ],
                itemsField: 'sampleSetSamples',
                editPageName: 'sampleSetSample',
                apiMethod: 'SampleSetSamples',
                claimName: 'SampleSetSamples',
                formTitle: 'Sample Set Sample',
                excelTitle: 'Sample Set Samples',
                hasEditPage: false,
            }
        },
    };
</script>
